import { useCallback } from "react";
import { HoverCard, HoverCardType } from "@fluentui/react/lib/HoverCard";
import { Text } from "@fluentui/react/lib/Text";

import { EntityIcon } from "Components/Generic/EntityIcon";
import { WithTranslator } from "Components/Generic/Translator";
import { getTranslatedFieldLabel } from "Utils/Field";
import { IMissingFieldsEntryProps } from "./IMissingFieldsEntryProps";
import { useMissingFieldsEntryStyles } from "./UseMissingFieldsEntryStyles";

export const MissingFieldsEntry = WithTranslator((props: IMissingFieldsEntryProps): JSX.Element => {
  const { entry, index, translator } = props;
  const styles = useMissingFieldsEntryStyles(entry.type, index);

  const onRenderPlainCard = useCallback(
    (missingFields: string[]) => (
      <div className={styles.card}>
        <div className={styles.cardName}>
          <Text variant="mediumPlus">{entry.name}</Text>
        </div>
        <div className={styles.cardFields}>
          <Text>
            {`${translator.get(`export.missingrequiredfields.title`, `Missing mandatory fields`)}: `}
            <br />
            {missingFields
              ?.map((fieldName: string) => getTranslatedFieldLabel(fieldName, entry.type, translator))
              ?.join(`, `) ?? translator.get(`generic.none`, `None`)}
          </Text>
        </div>
      </div>
    ),
    [entry, styles, translator]
  );

  return (
    <HoverCard
      className={styles.root}
      instantOpenOnClick
      plainCardProps={{ onRenderPlainCard, renderData: entry.missingFields }}
      type={HoverCardType.plain}
    >
      <div className={styles.entry}>
        <div className={styles.icon}>
          <EntityIcon type={entry.type} />
        </div>
        <div className={styles.label}>{`(${entry.missingFields?.length ?? 0}) ${entry.name}`}</div>
      </div>
    </HoverCard>
  );
});
